import { Reducer } from 'redux';
import { State, User, UserAction, UserTypes } from '../types';

const initialState = {
  currentUser: null,
};

const reducer: Reducer<State['globalUsers'], UserAction> = (
  state: State['globalUsers'] = initialState as State['globalUsers'],
  action: UserAction,
): State['globalUsers'] => {
  switch (action.type) {
    case UserTypes.SESSION:
      if (action.payload.hash) {
        return {
          ...state,
          session: action.payload.session,
          hash: action.payload.hash,
        };
      }
      return {
        ...state,
        session: action.payload.session,
      };
    case UserTypes.CLEAR_SESSION:
      return {
        ...state,
        currentUser: null,
        session: '',
        hash: '',
      };
    case UserTypes.LOGIN:
      return {
        ...state,
        currentUser: { ...state.currentUser, ...action.payload },
        usersUpdated: new Date(),
      };
    case UserTypes.UPDATE_AVAILABILITY:
      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          available: action.payload,
        } as User,
        usersUpdated: new Date(),
      };
    case UserTypes.UPDATE_TRANSLATION_ENABLED:
      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          translationEnabled: action.payload,
        } as User,
        usersUpdated: new Date(),
      };
    default:
      return state;
  }
};

export default reducer;
